<template>
<div>
  <md-whiteframe md-elevation="2" v-if="current" :style="'background-color:white;z-index:1000;position:absolute;margin-top:'+tooltipPos.y+'px;margin-left:'+tooltipPos.x+'px;padding:12px'">
    <span>{{current.value.toLocaleString()}} voix - {{(100*current.value/current.source.total).toFixed(1)}} % des expatriés de ce pays votent</span><br>
    <span>pour ce candidat, soit {{(100*current.value/current.target.total).toFixed(1)}} % de son total</span>
  </md-whiteframe>
  <md-toolbar id="navbar" class="md-whiteframe md-whiteframe-3dp">
    <div class="md-logo">
      <a href="https://koumoul.com/" style="text-decoration:none;">
        <md-layout md-row>
          <logo :colors="['#9C27B0', '#E1BEE7']"></logo>
          <h2 style="margin-left:8px;margin-top:18px;color:white;">Koumoul</h2>
        </md-layout>
      </a>
    </div>
    <md-layout md-flex></md-layout>
    <h1>1er tour des élection présidentielle 2017 - Expatriés</h1>
    <md-layout md-flex></md-layout>
    <a href="http://www.data.gouv.fr/fr/datasets/resultats-du-vote-des-francais-residant-a-letranger-au-premier-tour-de-lelection-presidentielle-2017/" class="md-button">Données brutes</a>
  </md-toolbar>
  <md-layout md-column>
    <md-layout md-row md-align="center">
      <h2 class="md-display-1">Dans quels pays se répartissent ces {{total.toLocaleString()}} votants ? Pour qui votent-ils ?</h2>
    </md-layout>
    <md-layout md-row md-align="center">
      <svg style="width:1000px;height:850px;" @mousemove="move($event)">
        <path :d="link.path" v-for="link in links" fill="none" :stroke="link.color" :stroke-opacity="current === link ? 0.8 : 0.4" :stroke-width="Math.max(1, link.dy)" transform="translate(200)" @mouseenter="select(link, $event)" @mouseleave="unselect"></path>
        <rect :x="node.x" :y="node.y" :width="node.dx" :height="node.dy" v-for="node in nodes" :fill="node.color || 'lightblue'" stroke="black" transform="translate(200)"></rect>
        <text :x="node.x + (node.color ? 240 : 110)" :y="node.y+node.dy/2-2" fill="black" v-for="node in nodes">{{capitalizeFirstLetter(node.name)}}</text>
        <text :x="node.x + (node.color ? 240 : 50)" :y="node.y+node.dy/2+14" fill="black" v-for="node in nodes">{{Number(node.total).toLocaleString()}} votes ({{(100*Number(node.total)/total).toFixed(1)}} %)</text>
      </svg>
    </md-layout>
  </md-layout>
</div>
</template>

<script>
import Logo from './Logo.vue'
const limit = 10000

var data = require('dsv-loader!../Tour_1_Resultats_par_pays_240417.csv')
const total = data.reduce((acc, current) => Number(current.Total) + acc, 0)

var candidates = Object.keys(data[0]).filter(k => k !== 'Pays' && k !== 'Total')
const other = data.filter(d => d.Total <= limit).reduce((acc, current) => Object.assign({}, ...candidates.concat(['Total']).map(c => ({
  [c]: Number(current[c]) + (acc[c] || 0)
}))), {})
data = data.filter(d => d.Total > limit)
other.Pays = 'Autres pays'
data.push(other)

const colors = {
  'Nicolas DUPONT-AIGNAN': 'darkblue',
  'Marine LE PEN': 'darkblue',
  'Emmanuel MACRON': 'orange',
  'Benoît HAMON': 'pink',
  'Nathalie ARTHAUD': 'red',
  'Philippe POUTOU': 'red',
  'Jacques CHEMINADE': 'grey',
  'Jean LASSALLE': 'grey',
  'Jean-Luc MÉLENCHON': 'red',
  'François ASSELINEAU': 'grey',
  'François FILLON': 'blue',
}

var countries = data.map(d => ({
  total: d.Total,
  name: d.Pays
}))

var nodes = countries.concat(candidates.map(c => ({
  name: c,
  color: colors[c],
  total: 0
})))
var links = []
data.forEach((d, i) => {
  candidates.forEach((c, j) =>  {
    nodes[countries.length + j].total += Number(d[c])
    links.push({
      source: i,
      target: countries.length + j,
      value: Number(d[c]),
      color: nodes[countries.length + j].color
    })
  })
})

const sankey = require('d3-sankey').sankey().size([600, 800]).nodePadding(24)
sankey.nodes(nodes)
sankey.links(links)

export default {
  name: 'app',
  components: {
    Logo
  },
  mounted() {
    this.$ua.trackView('ElectionsExpatriates')
  },
  computed: {
    nodes() {
      return this.sankey.nodes()
    },
    links() {
      return this.sankey.links().sort((a, b) => b.dy - a.dy).map(link => ({
        value: link.value,
        source: link.source,
        target: link.target,
        dy: link.dy,
        color: link.color,
        path: this.sankey.link()(link)
      }))
    }
  },
  data: () => ({
    sankey: sankey.layout(32),
    total: total,
    tooltipPos: {},
    current: null
  }),
  methods: {
    select(link, event) {
      this.current = link
      this.tooltipPos = {
        x: event.clientX - 160, // node.data.Description.length * 4,
        y: event.clientY - 72 + Math.max(document.documentElement.scrollTop,document.body.scrollTop)
      }
    },
    unselect() {
      this.current = null
    },
    move(event) {
      this.tooltipPos = {
        x: event.clientX - 160, // node.data.Description.length * 4,
        y: event.clientY - 72 + Math.max(document.documentElement.scrollTop,document.body.scrollTop)
      }
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
    }
  }
}
</script>

<style>
.md-toolbar {
  align-items: flex-start;
}

.md-toolbar .md-logo {
  text-align: center;
  margin-top: 4px;
  margin-bottom: 4px;
  margin-left: 4px;
}

li {
  height: 24px!important;
  width: 200px;
}

.logo-container {
  width: 56px;
  height: 56px;
  background-color: white;
  border-radius: 2px;
  box-shadow: inset 0 1px 8px rgba(0, 0, 0, .2), inset 0 3px 4px rgba(0, 0, 0, .14), inset 0 3px 3px -2px rgba(0, 0, 0, .12);
  /*box-shadow: 0 0 6px white;*/
}
</style>



// WEBPACK FOOTER //
// App.vue?1e22c9ae